/**
 * Espelho do enum `Action` definido em
 * ``src/permissions/enums.py`` no backend. Manter SYNC.
 */

export const Action = {
  USER_READ_ALL: "user.read_all",
  USER_CREATED: "user.created",
  USER_INVITED: "user.invited",
  USER_UPDATED: "user.updated",
  USER_DEACTIVATED: "user.deactivated",
  USER_REACTIVATED: "user.reactivated",
  USER_ADMIN_GRANTED: "user.admin_granted",
  USER_ADMIN_REVOKED: "user.admin_revoked",
  USER_PII_FILTER_ENABLED: "user.pii_filter_enabled",
  USER_PII_FILTER_DISABLED: "user.pii_filter_disabled",

  // Usuarios de servico (gestao admin-only).
  SERVICE_USER_CREATED: "service_user.created",
  SERVICE_USER_UPDATED: "service_user.updated",
  SERVICE_USER_DEACTIVATED: "service_user.deactivated",
  SERVICE_USER_REACTIVATED: "service_user.reactivated",
  SERVICE_USER_KEY_CREATED: "service_user.key_created",
  SERVICE_USER_KEY_REVOKED: "service_user.key_revoked",

  TEAM_CREATED: "team.created",
  TEAM_UPDATED: "team.updated",
  TEAM_DEACTIVATED: "team.deactivated",
  TEAM_REACTIVATED: "team.reactivated",
  TEAM_MEMBER_ADDED: "team.member_added",
  TEAM_MEMBER_ROLE_CHANGED: "team.member_role_changed",
  TEAM_MEMBER_REMOVED: "team.member_removed",

  COMPANY_CONTEXT_READ: "company_context.read",
  COMPANY_CONTEXT_UPDATED: "company_context.updated",

  KNOWLEDGE_BASE_CREATED: "knowledge_base.created",
  KNOWLEDGE_BASE_UPDATED: "knowledge_base.updated",
  KNOWLEDGE_BASE_DELETED: "knowledge_base.deleted",
  KNOWLEDGE_BASE_PERMISSION_GRANTED: "knowledge_base.permission_granted",
  KNOWLEDGE_BASE_PERMISSION_REVOKED: "knowledge_base.permission_revoked",

  DOCUMENT_UPLOADED: "document.uploaded",
  DOCUMENT_DELETED: "document.deleted",
  DOCUMENT_REINDEXED: "document.reindexed",

  LLM_MODEL_CREATED: "llm_model.created",
  LLM_MODEL_UPDATED: "llm_model.updated",
  LLM_MODEL_ACTIVATED: "llm_model.activated",
  LLM_MODEL_DEACTIVATED: "llm_model.deactivated",
  TEAM_ALLOWED_MODELS_UPDATED: "team_allowed_models.updated",

  MCP_SERVER_CREATED: "mcp_server.created",
  MCP_SERVER_UPDATED: "mcp_server.updated",
  MCP_SERVER_CREDENTIALS_UPDATED: "mcp_server.credentials_updated",
  MCP_SERVER_DELETED: "mcp_server.deleted",
  MCP_SERVER_PERMISSION_GRANTED: "mcp_server.permission_granted",
  MCP_SERVER_PERMISSION_REVOKED: "mcp_server.permission_revoked",

  // Skills (pacotes de instrucoes estilo SKILL.md)
  SKILL_CREATED: "skill.created",
  SKILL_UPDATED: "skill.updated",
  SKILL_DELETED: "skill.deleted",
  SKILL_PERMISSION_GRANTED: "skill.permission_granted",
  SKILL_PERMISSION_REVOKED: "skill.permission_revoked",

  // M4 Fase 6: agentes
  AGENT_CREATED: "agent.created",
  AGENT_UPDATED: "agent.updated",
  AGENT_DELETED: "agent.deleted",
  AGENT_DUPLICATED: "agent.duplicated",
  AGENT_VISIBILITY_CHANGED: "agent.visibility_changed",
  AGENT_KNOWLEDGE_BASES_CHANGED: "agent.knowledge_bases_changed",
  AGENT_MCPS_CHANGED: "agent.mcps_changed",
  AGENT_SKILLS_CHANGED: "agent.skills_changed",
  AGENT_RATED: "agent.rated",
  // Publish/install workflow (logica de permissao em can.ts):
  AGENT_PUBLISH_REQUESTED: "agent.publish_requested",
  AGENT_PUBLISH_APPROVED: "agent.publish_approved",
  AGENT_PUBLISH_REJECTED: "agent.publish_rejected",
  AGENT_INSTALLED: "agent.installed",
  AGENT_UNINSTALLED: "agent.uninstalled",
  AGENT_INSTALL_REQUESTED: "agent.install_requested",
  AGENT_INSTALL_APPROVED: "agent.install_approved",
  AGENT_INSTALL_REJECTED: "agent.install_rejected",

  // Templates de tom (admin)
  PROMPT_TONE_UPDATED: "prompt_tone.updated",

  // M5 Fase 7 + 9: runtime
  THREAD_CREATED: "thread.created",
  THREAD_UPDATED: "thread.updated",
  THREAD_CANCELLED: "thread.cancelled",
  THREAD_DELETED: "thread.deleted",
  HITL_DECIDED: "hitl.decided",

  // M6 Fase 8: unpublish (publish/install ja declarados acima)
  AGENT_UNPUBLISHED: "agent.unpublished",

  // M6 Fase 10: team sessions
  TEAM_SESSION_CREATED: "team_session.created",
  TEAM_SESSION_UPDATED: "team_session.updated",
  TEAM_SESSION_DELETED: "team_session.deleted",

  // M6 Hardening: audit log viewer (admin)
  AUDIT_LOG_LIST: "audit_log.list",
} as const;

export type ActionValue = (typeof Action)[keyof typeof Action];

export type Role = "manager" | "creator" | "user";
